import { render, staticRenderFns } from "./RoutesManage.vue?vue&type=template&id=3cab6a66&scoped=true"
import script from "./RoutesManage.vue?vue&type=script&lang=js"
export * from "./RoutesManage.vue?vue&type=script&lang=js"
import style0 from "./RoutesManage.vue?vue&type=style&index=0&id=3cab6a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab6a66",
  null
  
)

export default component.exports